// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ItiN","question":"styles_question__21dJ-","inputVisibleButton":"styles_inputVisibleButton__B7OS9","note":"styles_note__1mcCu"};